import { Box, Typography } from '@mui/material';

import { Wrapper } from './components/Wrapper';

import type { FC, ReactNode } from 'react';

interface TitleCellProps {
  subtitle?: string | null;
  title: string;
  aboveTitle: string;
  startAdornment?: ReactNode;
  endAdornment?: ReactNode;
}

export const TitleCell: FC<TitleCellProps> = ({
  subtitle,
  title,
  aboveTitle,
  startAdornment = null,
  endAdornment = null,
}) => (
  <Wrapper>
    {startAdornment}
    <Box display="grid">
      <Typography color="primary" fontSize="small" fontWeight="500" noWrap>
        {aboveTitle}
      </Typography>
      <Typography noWrap>{title}</Typography>
      {subtitle && (
        <Typography variant="caption" color="text.secondary" noWrap>
          {subtitle}
        </Typography>
      )}
    </Box>
    {endAdornment}
  </Wrapper>
);
